import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-6">PRIVACY POLICY</h1>

      <p className="mb-4"><strong>Last Updated Date:</strong> 09/02/2026</p>

      <p className="mb-4">
        PRObroker, a product of Vocal Connect Pvt. Ltd. (“We”, “Us” or “Our”) is dedicated to safeguarding Your privacy and ensuring the security of Your personal information. The purpose of this Privacy Policy (“Privacy Policy”) is to describe the statement of transparency. It describes what information We collect about You (referred to as “User”, “Your”) during Your Use and access of www.probroker.in (“Website”), why we collect this information, how we Use Your information, how We protect and share Your information, including Your rights. We are committed to complying with applicable laws of India including Information Technology Act, 2000 (as amended), Digital Personal Data Protection Act, 2023 (as per implementation), Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, Indian Contracts Act, 1872 and any other applicable rules, guidelines or judicial decisions in force in India.
      </p>

      <p className="mb-4">
        This Privacy Policy is issued in compliance with the Digital Personal Data Protection Act, 2023 (“DPDP Act”) and other applicable Indian laws as already mentioned above.
      </p>

      <p className="mb-4">
        This Privacy Policy explains how Vocal Connect Private Limited, operating the PRObroker platform (including www.probroker.in, associated dashboards and tools) (“PRObroker”, “we”, “us”, “our”), collects, uses, stores and discloses personal data and non-personal data in India.
      </p>

      <p className="mb-4">
        This Privacy Policy applies to all users of PRObroker, including registered brokers, their authorised staff and visitors (“you”, “user”) accessing our website or services within India.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Data Fiduciary Role & Scope:</h2>

      <p className="mb-4">
        PRObroker acts as a data fiduciary in respect of certain selective digital personal data that it collects or processes directly from or about you for the operation of its platform and services, subject to safeguards.
      </p>

      <p className="mb-4">
        We also processes public and public (semi) property related data (including data accessed from public portals or permitted sources) which may include personal data of property owners, occupiers or contacts, subject to applicable law and platform safeguards.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Categories of Personal Data:</h2>

      <p className="mb-4">
        We may collect, generate or process the following categories of personal data about you:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Name, Photograph (if voluntarily provided), gender, broker firm name acting as registration identifiers.</li>
        <li>Mobile number, email address, physical address</li>
        <li>Username, passwords, login timestamps, session identifiers, device identifiers, IP address and access logs.</li>
        <li>Subscription plan details, transaction identifiers, payment status, invoice details. We typically receive tokenised or masked details from payment aggregators rather than full card or UPI credentials.</li>
        <li>Brokerage firm name, team composition, office locations, preferred micro-markets and deal history as captured in our tools.</li>
        <li>Queries raised to support, grievance submissions, feedback, call records (if calls are recorded) and email/WhatsApp correspondence relating to platform use.</li>
        <li>Contact details of property owners or prospects that you upload or record into our tools.</li>
      </ul>

      <p className="mb-4">
        We do not intentionally collect sensitive personal data such as financial account credentials, government identifiers, health data, biometric identifiers, caste or religious data, except to the limited extent voluntarily provided in KYC documents where required by law or for fraud prevention at any time.
      </p>

      <p className="mb-4">We also process non-personal and aggregated data, including:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Property attributes: locality, building name, configuration, area, pricing ranges, commercial/residential type, available amenities, and property status as compiled from multiple authentic public and semi-public sources.</li>
        <li>Traffic statistics, anonymised heatmaps, feature usage, clickstream data and aggregated query patterns.</li>
        <li>Logs generated by servers, error events, performance metrics and security alerts.</li>
      </ul>

      <p className="mb-4">
        Non-personal data and anonymised datasets may be used for analytics, product improvement, benchmarking, and business intelligence, provided that no individual is reasonably identifiable.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Sources of Data:</h2>

      <p className="mb-4">We Source data directly from you:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>at the time of registration and/or subscription checkout and/or broker onboarding.</li>
        <li>when you upload, edit or manage property data, contacts or leads or</li>
        <li>when you communicate with us via phone, email, WhatsApp or in-platform tools.</li>
      </ul>

      <p className="mb-4">
        Indirectly from your use of the platform through cookies (non-advertising), local storage and similar technologies used for session management, security and performance and/or through server logs and automated monitoring tools.
      </p>

      <p className="mb-4">
        Certain non-personal and public information or datasets sourced from third-party sources such as open access public real estate portals, public notices, public APIs and other openly available web sources. Internal datasets created by our admin team from public or licensed sources, stored in sheets and internal databases that are logically separated from the public facing website.
      </p>

      <p className="mb-4">
        We may corroborate property related and broker related information using a combination of user inputs, public data and internal checks, without undertaking any legal or title verification.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Legal Basis and Purpose Limitation:</h2>

      <p className="mb-4">
        We process personal data strictly for one or more of the following purposes in alignment with the DPDP Act, 2023 and the IT Act, 2000:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>To create and manage your PRObroker account and user workspace.</li>
        <li>To provide you access to our property data, tools, broker collaboration features and dashboards.</li>
        <li>To manage subscriptions, invoicing, payment status and account lifecycle.</li>
        <li>To prevent fraud, unauthorised access, scraping, resale or misuse of property data.</li>
        <li>To respond to your support queries, grievances and legal notices.</li>
        <li>To comply with applicable laws, law enforcement requests, court orders and regulatory directions.</li>
        <li>To improve security, performance, user experience and features of the platform.</li>
        <li>To send you service related communications (e.g., platform changes, policy updates, incident alerts).</li>
      </ul>

      <p className="mb-4">
        Marketing communications, if any, will be limited, contextual and subject to your ability to opt out through provided channels.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Consent Mechanics, Deemed Consent and Withdrawal:</h2>

      <p className="mb-4">
        By creating an account or accessing Our product, you acknowledge that you have read this Privacy Policy and consent to the processing of your personal data as described, to the extent such consent is required under the laws of India.
      </p>

      <p className="mb-4">
        For certain uses, we may rely on explicit consent captured through clear, granular checkboxes or toggles that are not pre-ticked.
      </p>

      <p className="mb-4">We may rely on deemed consent or legitimate uses permitted under the DPDP Act in situations including:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Processing necessary for performance of a contract or provision of our services requested by you.</li>
        <li>Compliance with legal obligations and law enforcement requests.</li>
        <li>Reasonable purposes such as fraud prevention, network security and analytics, subject to safeguards.</li>
      </ul>

      <p className="mb-4">You may withdraw your consent at any time for processing that relies on consent:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>By using the account/settings page where available or</li>
        <li>By writing to our Grievance Officer at the email address provided below.</li>
      </ul>

      <p className="mb-4">
        On withdrawal of consent for essential processing, we may be unable to continue providing you the services, and we may deactivate or restrict your account accordingly.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Cookies and Tracking Technologies:</h2>

      <p className="mb-4">
        We currently does not deploy pixel based advertising cookies or third party advertising trackers.
      </p>

      <p className="mb-4">
        We may use strictly necessary and functional cookies or similar technologies for authentication and session continuity, load balancing, security and fraud detection as well as capturing your basic preferences and choices.
      </p>

      <p className="mb-4">
        Any future introduction of advertising or profiling cookies will be preceded by an updated notice and, where required, consent capture mechanisms.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Data Retention and Erasure:</h2>

      <p className="mb-4">
        We retain personal data only for as long as necessary to fulfil the purposes stated in this Privacy Policy or as required by applicable law.
      </p>

      <p className="mb-4">
        Illustratively, account and profile data is retained for the term of your account and for a reasonable period thereafter (example, 3 to 7 years) for legal, tax and audit purposes. The transaction and billing records are retained for periods mandated under tax and accounting laws. Logs and security data is retained for a limited period proportionate to security and legal requirements (example, 1 to 3 years). Property related data (including owner contact details) collected from public or internally verified sources are retained as part of our property databases as long as they remain operationally relevant, subject to legal rights of data principals.
      </p>

      <p className="mb-4">
        We may anonymise or aggregate data before deletion for legitimate business purposes.
      </p>

      <p className="mb-4">
        You may request erasure of your personal data, and we will comply subject to legal and operational constraints, including where retention is required by law, where erasure would seriously impair our ability to defend legal claims or ensure platform integrity, where the data has been irreversibly anonymised.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Data Principal Rights: Subject to the DPDP Act and applicable rules, you may exercise the following rights:</h2>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Right to obtain a summary of personal data processed by us and the processing activities.</li>
        <li>Right to request correction or updating of inaccurate or incomplete personal data.</li>
        <li>Right to request deletion of your personal data, subject to exceptions noted above.</li>
        <li>Right to raise queries or complaints regarding our data practices with our Grievance Officer.</li>
        <li>Right to nominate another individual to exercise your rights in the event of your incapacity or death, in accordance with DPDP requirements.</li>
      </ul>

      <p className="mb-4">
        Requests can be submitted through your account (where supported) or by emailing the Grievance Officer with sufficient details to identify you and your account.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Security Safeguards:</h2>

      <p className="mb-4">
        We implement reasonable technical and organisational measures to protect personal data from unauthorised access, disclosure, alteration or destruction. These may include:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Role-based access controls and internal database segregation for admin and sub-admin users.</li>
        <li>Unique logins for brokers as well as internal staff.</li>
        <li>Encrypted transmission and secure server configurations.</li>
        <li>Regular access logging, audit trails and anomaly detection.</li>
        <li>Periodic internal reviews of access rights and administrative privileges.</li>
      </ul>

      <p className="mb-4">
        No system can be guaranteed as perfectly secure, however, we aim to maintain security proportional to the nature and volume of data processed.
      </p>

      <p className="mb-4">
        In case of a data breach that is likely to cause significant harm, we will take steps to contain the breach, notify the CERN, affected users and regulators where required, and support remedial measures.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Cross-Border Data Transfers:</h2>

      <p className="mb-4">
        We currently operate with infrastructure and core data processing located within India and does not intentionally transfer personal data outside India for routine operations.
      </p>

      <p className="mb-4">
        If, in future, any cross border processing or storage is required (for example, use of overseas cloud service providers or support tools), we will ensure compliance with the DPDP Act’s restrictions and any government notifications applicable at that time.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Sharing and Disclosure of Data:</h2>

      <p className="mb-4">we may share personal data only in the following limited circumstances:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>With our service providers (such as hosting, security, payment processing and communication tools) under appropriate confidentiality and data protection obligations.</li>
        <li>With law enforcement agencies, government authorities or courts, where required under applicable law or pursuant to lawful orders.</li>
        <li>With professional advisors (lawyers, auditors, consultants) for legitimate business and legal purposes.</li>
        <li>In connection with a merger, acquisition or corporate reorganisation, subject to safeguards and continuity of protection. We do not sell any personal data for monetary consideration.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">Children’s Data:</h2>

      <p className="mb-4">
        The PRObroker platform is intended for use by adult professionals and business users only. We do not knowingly collect personal data of children (under the age prescribed by DPDP) and any such data should not be submitted. If you believe a child’s data has been provided, please contact the Grievance Officer for appropriate action.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Grievance Officer and Contact Details:</h2>

      <p className="mb-4">For any questions, requests, or complaints regarding this Privacy Policy or your personal data, you may contact:</p>

      <p className="mb-4">
        <strong>Grievance Officer:</strong> Hemant Solanki<br />
        <strong>Designation:</strong> Acting Grievance Officer<br />
        <strong>Email :</strong> grievance@probroker.in<br />
        <strong>Address:</strong>GF-001, Mauryansh Elanza, Shyamal Cross Rd, nr. PAREKH HOSPITAL, SATELITE, Shyamal, Ahmedabad, Gujarat 380015<br />
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Changes to this Privacy Policy:</h2>

      <p className="mb-4">
        We may update this Privacy Policy from time to time to reflect changes in law, technology or our services. Material changes will be notified through the platform or by reasonable means. Continued use of the services after changes become effective constitutes your acceptance of the updated Policy.
      </p>

      <h1 className="text-3xl font-semibold mt-10 mb-6">PROBROKER DATA USAGE POLICY:</h1>

      <h2 className="text-xl font-semibold mt-8 mb-3">Purpose:</h2>

      <p className="mb-4">
        This Data Usage Policy (“Policy”) governs your access to and use of property data, contact details, analytics and related information made available through PRObroker. This Policy is an integral part of the terms and must be read together with the Privacy Policy and other Platform Policies.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Nature of Property Data Access:</h2>

      <p className="mb-4">
        PRObroker provides access to propery related data including property attributes (type, configuration, size, locality, price bands, status), property owner or contact details, where available, analytics, aggregated insights and meta data derived from our internal processing. Sources include public data, internal collections by our teams, and property data contributed by brokers subject to this Policy.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Grant of License:</h2>

      <p className="mb-4">
        Subject to an active subscription and strict compliance with this Policy and the Terms, PRObroker grants you a limited, revocable, non-exclusive, non-transferable licence to access property data through the authorised interface, subject to your plan scope and role based permissions. Use such data solely for evaluating properties for your clients, contacting property owners or counterparties regarding legitimate real estate transactions, and internal business records and CRM. The licence is limited to use within India for your own brokerage or real estate services business.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Absolute Prohibitions:</h2>

      <p className="mb-4">
        You shall not, directly or indirectly resell, sub-license, redistribute, publish or provide bulk or systematic access to PRObroker property data to any third party by any means or by sharing your login credentials, whether for consideration or otherwise. You must not create, maintain or contribute to any derivative database or data product that is substantially based on PRObroker data (including any internal or external property database that replicates our datasets), you shall not clone, replicate, perform data scraping or create any competing platform, application, interface or service that substantially derives from Our property data, structure or selection or even use scraping tools, bots, automated scripts or browser extensions to harvest property data beyond ordinary on screen usage. You shall not export property data at scale (for example, by repeated downloads, screenshots or manual copying as well), except where PRObbroker explicitly provides export functionality and only within those limits. You shall not use property contact data to send spam, bulk unsolicited communications, or communications unrelated to genuine property transactions. You shall not bypass, tamper with or attempt to circumvent any code based access gates, internal sheet protections or technical controls implemented by Us.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Internal Use and Sharing:</h2>

      <p className="mb-4">
        You may share limited property data internally with your authorised team members solely to the extent necessary for servicing specific individuals or clients or deals, provided that such team members are bound by equivalent confidentiality and usage restrictions. You remain fully responsible for any misuse or breach by your team members or persons accessing the platform under your account.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Audit and Enforcement Rights:</h2>

      <p className="mb-4">To protect PRObroker’s legitimate interests and data integrity, we reserve the right to:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Monitor usage patterns, access logs and export activity for anomalies and indications of bulk extraction or misuse.</li>
        <li>Implement additional technical controls (rate limits, CAPTCHAs, device binding, and such measures, as and wherever required at any point in time) where abnormal usage is detected.</li>
        <li>Seek clarifications from you regarding suspicious usage and require remediation or explanations.</li>
      </ul>

      <p className="mb-4">
        You agree to cooperate with reasonable audit or enquiry requests and to provide access to relevant records (such as internal CRM snapshots, limited email evidence) if necessary to verify compliance, subject to appropriate confidentiality.
      </p>

      <p className="mb-4">
        In case of suspected or confirmed breach of this Policy, we may immediately suspend or terminate your access (with or without notice), disable export or high volume access for your account or take legal action, including claims for damages, injunctive relief and criminal complaints under applicable laws.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Intellectual Property:</h2>

      <p className="mb-4">
        All rights, title and interest in PRObroker’s property datasets, selection, arrangement and associated tools remain the exclusive proprietary property of PRObroker or its licensors. Nothing in this Policy transfers any ownership of data or intellectual property to you, except the limited usage rights expressly granted.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Survival:</h2>

      <p className="mb-4">
        All obligations and restrictions under this Policy survive termination of your subscription and apply to any retained copies or derivatives of Our data.
      </p>

     < p className="mb-4">
     By providing your contact details, you consent to receive promotional alerts, RCS messages, and WhatsApp notifications from PRObroker. You may opt out of receiving such communications at any time by following the unsubscribe instructions in the message or by contacting us directly.
     </p>
    </div>
  );
}
